import { DTA_SEARCH_MIN_LENGTH, fiduciarieMessages } from 'azshared';
import type { FiduciarieValidationError } from 'azshared';
import { IntlShape } from 'react-intl';

export const formatFiduciarieFieldError = (formatMessage: IntlShape['formatMessage'], error?: FiduciarieValidationError) => {
  switch (error) {
    case 'minLength':
      return formatMessage(fiduciarieMessages.minLengthError, { min: DTA_SEARCH_MIN_LENGTH });
    case 'required':
      return formatMessage(fiduciarieMessages.requiredField);
    case 'fiscalDataRequired':
      return formatMessage(fiduciarieMessages.fiscalDataRequired);
    case 'invalidFiscalCode':
      return formatMessage(fiduciarieMessages.invalidFiscalCode);
    case 'invalidVatCode':
      return formatMessage(fiduciarieMessages.invalidVatCode);
    case 'emailAlreadyInUse':
      return formatMessage(fiduciarieMessages.emailAlreadyInUse);
    case 'invalidField':
      return formatMessage(fiduciarieMessages.invalidField);
    default:
      return undefined;
  }
};
